import useTeamContext from '@maxpreps/shared/contexts/TeamContext';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import React from 'react';
import styled from 'styled-components';

export const StyledSeasonPickerSSR = styled.div`
  display: none;
`;

const SeasonPickerSSR: React.FC = () => {
  const teamContext = useTeamContext();
  const isAdmin = useIsAdmin();

  const { teamSeasonPickerData } = teamContext;

  const ssrLinkData = teamSeasonPickerData
    .filter(ss => ss.isPublished || isAdmin)
    .map(ss => ({
      label: `${ss.season} ${ss.year}`,
      href: ss.canonicalUrl
    }));

  return (
    <StyledSeasonPickerSSR>
      {ssrLinkData
        .filter((x, i, a) => a.indexOf(x) === i)
        .map(d => (
          <a href={d.href} key={d.label + d.href}>
            {d.label}
          </a>
        ))}
    </StyledSeasonPickerSSR>
  );
};

export default SeasonPickerSSR;
